import angular from 'angular';
import controlManagementDataServiceFactory from '../Components/TransactionMonitoring/ControlManagement/controlManagementDataService.factory';
import incidentManagementDataServiceFactory from '../Components/TransactionMonitoring/Incidents/incidentManagementDataService.factory';

export default angular
    .module('app.transactionMonitoring.factories', [])
    .factory('controlManagementDataService', controlManagementDataServiceFactory)
    .factory('incidentManagementDataService', incidentManagementDataServiceFactory)
    .name;